module.exports = __webpack_public_path__ + "img/iPhone12.0eab80b9.png";